import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { BaseQueryParams } from 'types/base-query-params';
import { PaginatedResponse } from 'types/dtos';
import { ResponseEndUserDto } from '../types/dtos';
import { constructQueryParams } from 'utils/query-params-builder';
import { APP_ENDPOINTS } from 'app/endpoints';
import { formatDate } from 'utils/date-helpers';

export type EndUsersQueryParams = BaseQueryParams;

export default (build: EndpointBuilder<BaseQueryFn, string, string>) =>
    build.query<PaginatedResponse<ResponseEndUserDto>, EndUsersQueryParams>({
        async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
            const endUsersResponse = await fetchWithBQ(constructQueryParams(APP_ENDPOINTS.END_USERS, _arg)); //Change to endUsers endpoint and change params to _arg

            if (endUsersResponse.error) {
                return {
                    error: endUsersResponse.error,
                };
            }

            const endUsers = endUsersResponse.data as PaginatedResponse<ResponseEndUserDto>;

            endUsers.content = endUsers.content.map((endUser) => {
                const email = endUser.account.email;
                const createdAt = formatDate(endUser.createdAt);

                return {
                    ...endUser,
                    email,
                    createdAt,
                };
            });

            return {
                data: endUsers,
            };
        },
        providesTags: ['endUsers'],
    });
